import React, { Fragment } from 'react';
import routes from 'library/Routes';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { getTranslate, getActiveLanguage, setActiveLanguage, getLanguages } from 'react-localize-redux';
import { removeUser, addUser } from 'actions/actions';
import classnames from 'classnames';
import UserHelper from 'infrastructure/UserHelper';
import { serviceLocator } from 'infrastructure/ServiceLocator';
import { AppBar, makeStyles, Grid, Typography } from '@material-ui/core';
import LayoutHelper from 'infrastructure/LayoutHelper';
import { withStyles } from '@material-ui/core/styles';
import { yellow, blue } from '@material-ui/core/colors';

class Footer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentWillMount() {}

  render() {
    const { translate, currentLanguage, classes, domainConfig } = this.props;
    const domain = domainConfig.domain;
    const isEnglish = currentLanguage === 'en_US';
    if (domain.custom) {
      const owner = domainConfig.owner;
      const termsAndConditions = UserHelper.getTermsAndConditions(owner);
      return (
        <footer className={classes.footer}>
          <Grid container spacing={1} className={classes.payments} justify="center">
            <Grid item>
              <img
                data-src={`${domainConfig.staticUrl}/visa_f.png`}
                alt="Visa"
                className="lazyload"
                style={{ height: '28px' }}
              />
            </Grid>
            <Grid item>
              {' '}
              <img
                data-src={`${domainConfig.staticUrl}/mastercard.svg`}
                className="lazyload"
                alt="Mastercard"
                style={{ height: '28px' }}
              />
            </Grid>
          </Grid>
          <Typography align="center">
            <a href={termsAndConditions} rel="nofollow" className={classes.orangeLink} target="_blank">
              {translate('common.termsAndConditions')}
            </a>
          </Typography>

          <a className={classes.orangeLink} target="_blank" href={`https://${domain.parent}/business`}>
            <Grid container alignItems="center" justify="center">
              <Grid item>{this.props.translate('common.poweredBy')}</Grid>
              <Grid item>
                <img
                  width="70"
                  height="21"
                  className="lazyload"
                  alt="Voopty Logo"
                  data-src={`${domainConfig.staticUrl}/voopty.png`}
                />
              </Grid>
            </Grid>
          </a>

          <Typography align="center" className={classes.copy}>
            {moment().year()} Copyright {domain.id}
          </Typography>
          {this.renderMadeInUkraine()}
        </footer>
      );
    }
    return (
      <footer className={classes.footer}>
        <Grid container direction="row" justify="flex-start" alignItems="flex-start" className={classes.innerContainer}>
          <Grid item xs={12} sm>
            <Fragment>
              <Grid container spacing={1} className={classes.payments}>
                <Grid item>
                  <img
                    data-src={`${domainConfig.staticUrl}/visa_f.png`}
                    alt="Visa"
                    className="lazyload"
                    style={{ height: '28px' }}
                  />
                </Grid>
                <Grid item>
                  {' '}
                  <img
                    data-src={`${domainConfig.staticUrl}/mastercard.svg`}
                    className="lazyload"
                    alt="Mastercard"
                    style={{ height: '28px' }}
                  />
                </Grid>
              </Grid>

              <ul className={classes.socialIcons}>
                <li>
                  <a
                    className={classes.orangeLink}
                    href={
                      isEnglish
                        ? 'https://www.facebook.com/vooptyBot'
                        : 'https://www.facebook.com/Voopty-Inside-278299072959477/'
                    }
                  >
                    <i className="fa fa-facebook fa-fw fa-2x"> </i>
                  </a>
                </li>
                <li>
                  <a
                    className={classes.orangeLink}
                    href={
                      isEnglish ? 'https://www.instagram.com/voopty_dc/' : 'https://www.instagram.com/voopty_inside/'
                    }
                  >
                    <i className="fa fa-instagram fa-fw fa-2x"> </i>
                  </a>
                </li>
              </ul>
            </Fragment>
            <Typography className={classes.footerTitle} align="left" variant="h6">
              Contact Us
            </Typography>
            <Typography>
              <a className={classes.orangeLink} href="mailto:support@voopty.com">
                <i className="fa fa-envelope-o fa-fw"> </i>support@voopty.com
              </a>
            </Typography>
            {!isEnglish && (
              <Fragment>
                {/*<Typography><a className={classes.orangeLink}*/}
                {/*               href="tel:+380994894280">+380994894280</a></Typography>*/}
                {/*<br/>*/}
                <Grid container spacing={1}>
                  <Grid item>
                    <a
                      className={classnames(classes.phone, 'lazyload')}
                      href="tel:+380980365772"
                      data-bgset={`${domainConfig.staticUrl}/icon-phone.png`}
                    ></a>
                  </Grid>
                  {/* <Grid item>
                                <a className={classnames(classes.viber, "lazyload")}
                                   data-bgset={`${domainConfig.staticUrl}/icon-viber.png`}
                                    href={`viber://chat?number=+380994894280`} />
                            </Grid> */}
                  <Grid item>
                    <a
                      className={classnames(classes.telegram, 'lazyload')}
                      data-bgset={`${domainConfig.staticUrl}/icon-telegram.png`}
                      href="https://t.me/vooptysupport"
                    ></a>
                  </Grid>
                </Grid>
              </Fragment>
            )}
          </Grid>
          <Grid item xs={12} sm>
            <Typography className={classes.footerTitle} align="left" variant="h6">
              {translate('landingBiz.learnMore')}
            </Typography>
            <a className={classes.orangeLink} href={routes.business()}>
              {translate('landingBiz.readMoreTitle')}
            </a>
            <br />
            <a
              className={classes.orangeLink}
              ref="nofollow"
              href="https://landing.voopty.com.ua/functions/"
              target="_blank"
              rel="noopener noreferrer"
            >
              {translate('common.functions')}
            </a>
            <br />
            <a
              className={classes.orangeLink}
              ref="nofollow"
              href="https://landing.voopty.com.ua/tariffs/"
              target="_blank"
              rel="noopener noreferrer"
            >
              {translate('common.pricing')}
            </a>
            <br />
            <a
              className={classes.orangeLink}
              ref="nofollow"
              href="https://landing.voopty.com.ua/blog/"
              target="_blank"
              rel="noopener noreferrer"
            >
              {translate('common.blog')}
            </a>

            <ul className={classes.footerLinks}>
              <li>
                <a href={routes.aboutUs()} rel="nofollow" className={classes.orangeLink}>
                  {translate('common.about')}
                </a>
              </li>
              <li>
                <a
                  href={'https://landing.voopty.com.ua/privacy-policy/'}
                  className={classes.orangeLink}
                  rel="nofollow"
                  target="_blank"
                >
                  {translate('common.privacyPolicy')}
                </a>
              </li>
              {/*<li><a className={classes.orangeLink}*/}
              {/*       href={routes.landings.language()}>{translate("landingBiz.readMore.readMoreLeanding1")}</a>*/}
              {/*</li>*/}
              {/*<li><a className={classes.orangeLink}*/}
              {/*       href={routes.landings.skiSchool()}>{translate("landingBiz.readMore.readMoreLeanding2")}</a>*/}
              {/*</li>*/}
              {/*<li><a className={classes.orangeLink}*/}
              {/*       href={routes.landings.crossfit()}>{translate("landingBiz.readMore.crossfit")}</a>*/}
              {/*</li>*/}
              {/*<li><a className={classes.orangeLink}*/}
              {/*       href={routes.landings.fitness()}>{translate("landingBiz.readMore.readMoreLeanding3")}</a>*/}
              {/*</li>*/}
              {/*<li><a className={classes.orangeLink}*/}
              {/*       href={routes.landings.music()}>{translate("landingBiz.readMore.readMoreLeanding4")}</a>*/}
              {/*</li>*/}
              {/*<li><a className={classes.orangeLink}*/}
              {/*       href={routes.landings.childcare()}>{translate("landingBiz.readMore.readMoreLeanding5")}</a>*/}
              {/*</li>*/}
              {/*<li><a className={classes.orangeLink}*/}
              {/*       href={routes.landings.preschool()}>{translate("landingBiz.readMore.readMoreLeanding6")}</a>*/}
              {/*</li>*/}
              {/*<li><a className={classes.orangeLink}*/}
              {/*       href={routes.landings.acting()}>{translate("landingBiz.readMore.readMoreLeanding7")}</a>*/}
              {/*</li>*/}
              {/*<li><a className={classes.orangeLink}*/}
              {/*       href={routes.landings.tutoring()}>{translate("landingBiz.readMore.readMoreLeanding8")}</a>*/}
              {/*</li>*/}
              {/*<li><a className={classes.orangeLink}*/}
              {/*       target="_blank"*/}
              {/*       href="https://wod.voopty.com">WOD Insight</a>*/}
              {/*</li>*/}
              {/*<li><a className={classes.orangeLink}*/}
              {/*       href="https://itshappening.voopty.com/">{translate("landingBiz.readMore.itshappening")}</a>*/}
              {/*</li>*/}
              {/*<li><a className={classes.orangeLink}*/}
              {/*href="https://onclass.voopty.com/">{translate("landingBiz.readMore.onclass")}</a>*/}
              {/*</li>*/}
            </ul>
          </Grid>
        </Grid>
        <Grid container direction="row" justify="center" alignItems="center">
          <Grid className={classes.footerCopy} item xs={12}>
            <Typography align="center" className={classes.copy}>
              {translate('landingBiz.footerCopy')}
            </Typography>
            {this.renderMadeInUkraine()}
          </Grid>
        </Grid>
      </footer>
    );
  }

  renderMadeInUkraine = () => {
    const { classes, domainConfig } = this.props;
    const domain = domainConfig.domain;
    if (domain.countryCode === 'UA') {
      return (
        <Typography align="center">
          <span className={classes.yellow}>Made in </span>
          <span className={classes.blue}>Ukraine</span>
        </Typography>
      );
    }
  };
  renderBlog = () => {
    const { classes, domainConfig } = this.props;
    const domain = domainConfig.domain;
    if (domain.blog) {
      return (
        <li>
          <a className={classes.orangeLink} href={domain.blog}>
            {this.props.translate('common.blog')}
          </a>
        </li>
      );
    }
  };
}

const mapStateToProps = (state) => ({
  translate: getTranslate(state.locale),
  currentLanguage: getActiveLanguage(state.locale).code,
  langs: getLanguages(state.locale),
  user: state.user,
  domainConfig: state.domain,
});

const mapDispatchToProps = (dispatch) => {
  return {
    root: () => {
      dispatch(push(`${routes.root()}`));
    },
    toLogin: () => {
      dispatch(push(`${routes.login()}`));
    },
    toMyStudios: () => {
      dispatch(push(`${routes.myStudios()}`));
    },
    toCreateStudio: () => {
      dispatch(push(`${routes.createStudio()}`));
    },
    toSearch: () => {
      dispatch(push(`${routes.search()}`));
    },
    toMyClients: () => {
      dispatch(push(`${routes.myClients()}`));
    },
    toBilling: () => {
      dispatch(push(`${routes.billing()}`));
    },
    toMyExpenses: () => {
      dispatch(push(`${routes.myExpenses()}`));
    },
    toPaymentReport: () => {
      dispatch(push(`${routes.paymentReport()}`));
    },
    toMyAccount: () => {
      dispatch(push(`${routes.myAccount()}`));
    },
    changePassword: () => {
      dispatch(push(`${routes.changePassword()}`));
    },
    logOff: () => {
      let api = serviceLocator.clientUserApi;
      api.killSession();
      dispatch(removeUser());
      dispatch(push(`${routes.login()}`));
    },
    toMyClasses: () => {
      dispatch(push(`${routes.myClasses()}`));
    },
    toMyStudioClasses: (studioClient) => {
      dispatch(
        push(
          `${routes.studioClientClasses({
            ownerId: studioClient.ownerId,
            studioClientId: studioClient._id,
          })}`
        )
      );
    },
    me: () => {
      dispatch(push(`${routes.me()}`));
    },
    removeUser: function () {
      dispatch(removeUser());
    },
    changeLang: function (lang) {
      let api = serviceLocator.clientUserApi;
      api.setLang(lang);
      dispatch(setActiveLanguage(lang));
    },
  };
};

export default withStyles((theme) => ({
  toolbar: theme.mixins.toolbar,
  content: {
    display: 'flex',
    height: '100%',
    overflow: 'hidden',
  },
  main: {
    flexGrow: 1,
    height: '100%',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  scroller: {
    height: '100%',
    overflow: 'auto',
    '-webkit-overflow-scrolling': 'touch',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    '& > *': {
      flex: '1 0 auto',
    },
  },
  appBar: {
    padding: '12px 16px',
    zIndex: theme.zIndex.drawer + 1,
  },
  homeLink: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1 0 auto',
    color: theme.palette.primary.contrastText,
    '&:hover': {
      color: theme.palette.primary.contrastText,
      textDecoration: 'none',
    },
  },
  logoText: {
    fontSize: '12px',
  },
  footer: {
    width: '100%',
    overflow: 'hidden',
    padding: theme.spacing(4, 4, 4, 6),
    backgroundColor: theme.palette.secondary.dark,
    fontWeight: '300',
  },
  innerContainer: {
    maxWidth: 1360,
    margin: '0 auto',
  },
  footerCopy: {
    padding: theme.spacing(4, 0, 0),
  },
  copy: {
    color: theme.palette.primary.light,
    margin: 0,
    fontSize: '12px',
  },
  footerLinks: {
    margin: theme.spacing(0, 0, 2),
    padding: 0,
    listStyle: 'none',
    fontSize: '12px',
    '& > a': {
      color: theme.palette.primary.main,
    },
  },

  orangeLink: {
    color: theme.palette.primary.main,
    fontSize: '12px',
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
      color: theme.palette.primary.main,
    },
  },
  footerTitle: {
    color: theme.palette.primary.light,
    fontSize: '14px',
    textTransform: 'uppercase',
  },
  socialIcons: {
    margin: '0',
    padding: theme.spacing(1, 0, 2),
    listStyle: 'none',

    '& > li': {
      display: 'inline-block',
    },
  },
  socialLink: {
    fontSize: '14px',
  },
  yellow: {
    color: yellow[500],
  },
  blue: {
    color: blue[500],
  },
  payments: {
    paddingBottom: theme.spacing(1),
  },
  viber: {
    display: 'inline-block',
    width: '25px',
    height: '25px',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
  },
  telegram: {
    display: 'inline-block',
    width: '25px',
    height: '25px',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
  },
  phone: {
    display: 'inline-block',
    width: '25px',
    height: '25px',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
  },
}))(connect(mapStateToProps, mapDispatchToProps)(Footer));
